/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2
 */

export const ActionComponentTypename = 'com.hubspot.ai.agent.models.core.ActionComponent';
export const ActionComponentDiscriminant = 'ACTION';
export const ActionComponentDiscriminantKey = 'type';
export const AgentComponentTypename = 'com.hubspot.ai.agent.models.core.AgentComponent';
export const AgentComponentDiscriminant = 'AGENT';
export const AgentComponentDiscriminantKey = 'type';
export const AgentInputDiscriminantKey = '@type';
export const AgentTemplateComponentTypename = 'com.hubspot.ai.agent.models.core.AgentTemplateComponent';
export const AgentTemplateComponentDiscriminant = 'AGENT_TEMPLATE';
export const AgentTemplateComponentDiscriminantKey = 'type';
export const AviatorAgentComponentTypename = 'com.hubspot.ai.agent.models.core.AviatorAgentComponent';
export const AviatorAgentComponentDiscriminant = 'AVIATOR_SUBAGENT';
export const AviatorAgentComponentDiscriminantKey = 'type';
export const BooleanAgentInputTypename = 'com.hubspot.ai.agent.models.core.BooleanAgentInput';
export const BooleanAgentInputDiscriminant = 'boolean';
export const BooleanAgentInputDiscriminantKey = '@type';
export const BuiltInToolComponentTypename = 'com.hubspot.ai.agent.models.core.BuiltInToolComponent';
export const BuiltInToolComponentDiscriminant = 'BUILT_IN';
export const BuiltInToolComponentDiscriminantKey = 'type';
export const ChirpRpcComponentTypename = 'com.hubspot.ai.agent.models.core.ChirpRpcComponent';
export const ChirpRpcComponentDiscriminant = 'CHIRP_RPC';
export const ChirpRpcComponentDiscriminantKey = 'type';
export const ChirpToolBundleComponentTypename = 'com.hubspot.ai.agent.models.core.ChirpToolBundleComponent';
export const ChirpToolBundleComponentDiscriminant = 'CHIRP_TOOL_BUNDLE';
export const ChirpToolBundleComponentDiscriminantKey = 'type';
export const ComponentV2DiscriminantKey = 'type';
export const ConnectionDetailDiscriminantKey = 'type';
export const CreatedFromDiscriminantKey = 'origin';
export const CrmCardConnectionDataTypename = 'com.hubspot.ai.agent.models.core.CrmCardConnectionData';
export const CrmCardConnectionDataDiscriminant = 'CRM_CARD';
export const CrmCardConnectionDataDiscriminantKey = 'type';
export const CrmObjectCoordinatesAgentInputTypename = 'com.hubspot.ai.agent.models.core.CrmObjectCoordinatesAgentInput';
export const CrmObjectCoordinatesAgentInputDiscriminant = 'object';
export const CrmObjectCoordinatesAgentInputDiscriminantKey = '@type';
export const FileAgentInputTypename = 'com.hubspot.ai.agent.models.core.FileAgentInput';
export const FileAgentInputDiscriminant = 'file';
export const FileAgentInputDiscriminantKey = '@type';
export const FilesAgentInputTypename = 'com.hubspot.ai.agent.models.core.FilesAgentInput';
export const FilesAgentInputDiscriminant = 'files';
export const FilesAgentInputDiscriminantKey = '@type';
export const HookComponentTypename = 'com.hubspot.ai.agent.models.core.HookComponent';
export const HookComponentDiscriminant = 'HOOK';
export const HookComponentDiscriminantKey = 'type';
export const KnowledgeBoxComponentTypename = 'com.hubspot.ai.agent.models.core.KnowledgeBoxComponent';
export const KnowledgeBoxComponentDiscriminant = 'KNOWLEDGE_BOX';
export const KnowledgeBoxComponentDiscriminantKey = 'type';
export const ListAgentInputTypename = 'com.hubspot.ai.agent.models.core.ListAgentInput';
export const ListAgentInputDiscriminant = 'list';
export const ListAgentInputDiscriminantKey = '@type';
export const MapAgentInputTypename = 'com.hubspot.ai.agent.models.core.MapAgentInput';
export const MapAgentInputDiscriminant = 'map';
export const MapAgentInputDiscriminantKey = '@type';
export const McpServerComponentTypename = 'com.hubspot.ai.agent.models.core.McpServerComponent';
export const McpServerComponentDiscriminant = 'MCP_SERVER';
export const McpServerComponentDiscriminantKey = 'type';
export const McpServerV2ComponentTypename = 'com.hubspot.ai.agent.models.core.McpServerV2Component';
export const McpServerV2ComponentDiscriminant = 'MCP_SERVER_V2';
export const McpServerV2ComponentDiscriminantKey = 'type';
export const NullAgentInputTypename = 'com.hubspot.ai.agent.models.core.NullAgentInput';
export const NullAgentInputDiscriminant = 'null';
export const NullAgentInputDiscriminantKey = '@type';
export const NumberAgentInputTypename = 'com.hubspot.ai.agent.models.core.NumberAgentInput';
export const NumberAgentInputDiscriminant = 'number';
export const NumberAgentInputDiscriminantKey = '@type';
export const PortabilityCreatedFromTypename = 'com.hubspot.ai.agent.models.core.PortabilityCreatedFrom';
export const PortabilityCreatedFromDiscriminant = 'PORTABILITY';
export const PortabilityCreatedFromDiscriminantKey = 'origin';
export const RecommendationCreatedFromTypename = 'com.hubspot.ai.agent.models.core.RecommendationCreatedFrom';
export const RecommendationCreatedFromDiscriminant = 'RECOMMENDATION';
export const RecommendationCreatedFromDiscriminantKey = 'origin';
export const SkillComponentTypename = 'com.hubspot.ai.agent.models.core.SkillComponent';
export const SkillComponentDiscriminant = 'SKILL';
export const SkillComponentDiscriminantKey = 'type';
export const StringAgentInputTypename = 'com.hubspot.ai.agent.models.core.StringAgentInput';
export const StringAgentInputDiscriminant = 'string';
export const StringAgentInputDiscriminantKey = '@type';
export const WebhookComponentTypename = 'com.hubspot.ai.agent.models.core.WebhookComponent';
export const WebhookComponentDiscriminant = 'WEBHOOK';
export const WebhookComponentDiscriminantKey = 'type';
export const WorkflowConnectionDataTypename = 'com.hubspot.ai.agent.models.core.WorkflowConnectionData';
export const WorkflowConnectionDataDiscriminant = 'WORKFLOW';
export const WorkflowConnectionDataDiscriminantKey = 'type';

/**
 *  The editor's unsaved state, applied with the same rules as {@code updateAgentInstanceV3} before
 *  the agent is unpublished.
 */

/**
 *  Request to update the "metadata" (toolbar) fields of an agent instance: name, description, and
 *  icon. Unlike {@link PatchAgentInstanceRequestIF}, updating these fields does not create a new
 *  snapshot/version, since they do not change the agent's behavior.
 */

/**
 *  Response for {@link UpdateAgentMetadataRequestIF}. Returns only the updated instance, since a
 *  metadata edit does not change trigger flows, permissions, or the active snapshot (the snapshot id
 *  is still available via {@link AgentInstanceV2#getSnapshotId()}).
 */

/**
 *  Represents a validation error for a specific component (action, knowledge box, etc.).
 *  This structured format allows the frontend to construct user-facing error messages.
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FieldValueDiscriminantKey = '@type';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export const getAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstance',
  auth: 'app',
  fingerprint: 'luxHuQpJJYjc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesByIDsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByIDs',
  auth: 'app',
  fingerprint: 'v_Hi8JpYU3gGmjrIbILShSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesMetadataByIDsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesMetadataByIDs',
  auth: 'app',
  fingerprint: 'KkCtLaXxTCouhohdCRceWic3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesWithSnapshotsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesWithSnapshots',
  auth: 'app',
  fingerprint: '9QKX_6KF_GH46JzOgIl4SCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentInstancesByWorkflowIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByWorkflowId',
  auth: 'app',
  fingerprint: 'jhR4yXLMTW1el77g2jQ59Sc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActiveAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getActiveAgentInstances',
  auth: 'app',
  fingerprint: 'tt8k1TqizUbrdg7NfzqL_ic3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'listAgentInstances',
  auth: 'app',
  fingerprint: 'Ck0qC16a3i3rdg7NfzqL_ic3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'searchAgentInstances',
  auth: 'app',
  fingerprint: 'QfOt54bu5dnrdg7NfzqL_ic3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createAgentInstance',
  auth: 'app',
  fingerprint: 'mou5rilMa7oFNFx6FbjN9Sc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceV2',
  auth: 'app',
  fingerprint: 'sCfRHXdOZonc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceV3Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceV3',
  auth: 'app',
  fingerprint: 'OPWq5tjWrxnc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const patchAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'patchAgentInstance',
  auth: 'app',
  fingerprint: 'BLNX__ZyDLHc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentMetadataRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentMetadata',
  auth: 'app',
  fingerprint: '61HkWFDvVbx7xtM3Mk5EACc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentAvailabilityRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentAvailability',
  auth: 'app',
  fingerprint: 'Ogp6B8VUuGPc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const unpublishAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'unpublishAgentInstance',
  auth: 'app',
  fingerprint: 'VNxqAkF4Adjc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resetToLatestTemplateRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'resetToLatestTemplate',
  auth: 'app',
  fingerprint: 'Im2kC-4d0BuhfU8GFqWItSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'softDeleteAgentInstance',
  auth: 'app',
  fingerprint: 'luxHuQpJJYhzxnLXxOhAlyc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteAgentInstanceV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'softDeleteAgentInstanceV2',
  auth: 'app',
  fingerprint: 'bquNPpxFM9hzxnLXxOhAlyc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createInstanceFromTemplateRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createInstanceFromTemplate',
  auth: 'app',
  fingerprint: '8XE4Oz-YCFAdPRStO8zNUCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createInstanceFromTemplateByGlobalIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createInstanceFromTemplateByGlobalId',
  auth: 'app',
  fingerprint: 'FMIVBMCv7ocdPRStO8zNUCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneAgentInstanceRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneAgentInstance',
  auth: 'app',
  fingerprint: 'IDPzP_Tubm0dPRStO8zNUCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneAgentsForFlowRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneAgentsForFlow',
  auth: 'app',
  fingerprint: 'LVwvv72TyJlehC9hm_tAoSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstancesByTemplateIdsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getInstancesByTemplateIds',
  auth: 'app',
  fingerprint: 'Bao0fja8a35i7bgkmuGn_Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstancesByGlobalIdRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getInstancesByGlobalId',
  auth: 'app',
  fingerprint: 'yPtD4Qwpkj-tVZ9-DZ6LtSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceOwnerRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceOwner',
  auth: 'app',
  fingerprint: 'biKggbtMJGFzxnLXxOhAlyc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAgentInstanceFromSnapshotRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceFromSnapshot',
  auth: 'app',
  fingerprint: 'vxmtmtyT79zc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneInstanceFromSnapshotRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneInstanceFromSnapshot',
  auth: 'app',
  fingerprint: 'jfr4Elt4T0UdPRStO8zNUCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateAgentInstanceReadinessRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'validateAgentInstanceReadiness',
  auth: 'app',
  fingerprint: '7UOpVPNjQSZHKNNd4MLGeCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateAgentInstanceReadinessV2Rpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'validateAgentInstanceReadinessV2',
  auth: 'app',
  fingerprint: '_y3TSpR__PPlnnLyhTfIOSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkValidateAgentInstancesReadinessRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkValidateAgentInstancesReadiness',
  auth: 'app',
  fingerprint: 'ate6fB_EofplU4ciiiItdic3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkCreateAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkCreateAgentInstances',
  auth: 'app',
  fingerprint: 'av4zjDNJYTYr3lBdYSDWayc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkCreateAgentInstancesByKeyRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkCreateAgentInstancesByKey',
  auth: 'app',
  fingerprint: 'af9mI7OiwG81EY0Sbex4fSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkSoftDeleteAgentInstancesRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkSoftDeleteAgentInstances',
  auth: 'app',
  fingerprint: 'lQSah62WeHRlIE2fHG1Qwyc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAgentConnectionsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentConnections',
  auth: 'app',
  fingerprint: 'L5P9kdUDyVu5RJ9mIMBXkSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getGlobalAgentConnectionsRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getGlobalAgentConnections',
  auth: 'app',
  fingerprint: 'Al5CHVrqM_eOIu_L9G7zECc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listAgentInstancesWithInvocabilityRpc = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'listAgentInstancesWithInvocability',
  auth: 'app',
  fingerprint: 'bGOX9ZnU2z5H3rWH38_sHSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};